import React, { useState } from 'react';
import './IntroVideo.scss';
import brand1 from '../../brand1.svg';

const IntroVideo = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [thumbnailError, setThumbnailError] = useState(false);
  
  // Replace with your actual introduction video ID
  const introVideoId = "KXIdNIouwHY"; // About Organic Greens Hub video
  
  const handlePlayVideo = () => {
    setIsPlaying(true);
  };

  const handleThumbnailError = () => {
    setThumbnailError(true);
  };

  return (
    <div className="intro-video-section">
      <div className="container">
        <h2>About Organic Greens Hub</h2>
        <p className="intro-subtitle">Learn about our mission to provide fresh, organic produce</p>
        
        <div className="video-container">
          {!isPlaying ? (
            <div className="video-thumbnail" onClick={handlePlayVideo}>
              <img 
                src={thumbnailError ? brand1 : `https://img.youtube.com/vi/${introVideoId}/hqdefault.jpg`}
                alt="About Organic Greens Hub"
                onError={handleThumbnailError}
              />
              <div className="play-overlay">
                <div className="play-button-large">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M8 5v14l11-7z"/>
                  </svg>
                </div>
                <div className="play-text">
                  <h3>About Organic Greens Hub</h3>
                  <p>Learn about our mission to provide fresh, organic produce</p>
                </div>
              </div>
            </div>
          ) : (
            <div className="video-player">
              <iframe
                width="100%"
                height="400"
                src={`https://www.youtube.com/embed/${introVideoId}?autoplay=1&rel=0`}
                title="About Organic Greens Hub"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                allowFullScreen
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
              ></iframe>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default IntroVideo;